import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        backgroundColor: "#f8f9fa",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      {/* Logo */}
      <Link to="/">
        <img
          src="/logo.ico"
          alt="GracePresenter Logo"
          style={{ height: "50px" }}
        />
      </Link>
      <nav>
        <Link to="/" style={{ margin: "0 10px", textDecoration: "none", color: "#333" }}>
          Home
        </Link>
        <Link to="/downloads" style={{ margin: "0 10px", textDecoration: "none", color: "#333" }}>
          Downloads
        </Link>
        <a href="#features" style={{ margin: "0 10px", textDecoration: "none", color: "#333" }}>
          Features
        </a>
        <a href="#about" style={{ margin: "0 10px", textDecoration: "none", color: "#333" }}>
          About
        </a>
        <a href="#contact" style={{ margin: "0 10px", textDecoration: "none", color: "#333" }}>
          Contact
        </a>
      </nav>
    </header>
  );
}

export default Header;
